import * as React from 'react';

const SIZE_MAP = {
  small: { width: 16, height: 16 },
  medium: { width: 20, height: 20 },
  large: { width: 24, height: 24 },
} as const;

const SparkleIcon = ({ size = 'large' }: { size: keyof typeof SIZE_MAP }) => {
  const { width, height } = SIZE_MAP[size];

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.1865 4.2688C10.4232 3.68917 11.2438 3.68917 11.4805 4.2688L12.7627 7.40942C13.4726 9.14795 14.8523 10.5276 16.5908 11.2375L19.7314 12.5198C20.3111 12.7564 20.3111 13.5771 19.7314 13.8137L16.5908 15.0959C14.8521 15.8059 13.4726 17.1863 12.7627 18.925L11.4805 22.0657C11.2438 22.6453 10.4232 22.6452 10.1865 22.0657L8.9043 18.925C8.19436 17.1862 6.81403 15.8059 5.0752 15.0959L1.93457 13.8137C1.35515 13.577 1.35501 12.7564 1.93457 12.5198L5.0752 11.2375C6.81397 10.5276 8.19434 9.14817 8.9043 7.40942L10.1865 4.2688ZM18.6123 1.76099C18.7542 1.41354 19.2458 1.41354 19.3877 1.76099L19.9932 3.24243C20.135 3.58977 20.4105 3.86523 20.7578 4.00708L22.2393 4.61255C22.5867 4.7544 22.5867 5.24608 22.2393 5.38794L20.7578 5.99341C20.4105 6.13526 20.135 6.4107 19.9932 6.75806L19.3877 8.2395C19.2458 8.58695 18.7542 8.58695 18.6123 8.2395L18.0068 6.75806C17.865 6.4107 17.5895 6.13526 17.2422 5.99341L15.7607 5.38794C15.4133 5.24608 15.4133 4.7544 15.7607 4.61255L17.2422 4.00708C17.5895 3.86523 17.865 3.58977 18.0068 3.24243L18.6123 1.76099Z"
        fill="url(#paint0_linear_42_23148)"
      />
      <path
        d="M10.1865 4.2688C10.4232 3.68917 11.2438 3.68917 11.4805 4.2688L12.7627 7.40942C13.4726 9.14795 14.8523 10.5276 16.5908 11.2375L19.7314 12.5198C20.3111 12.7564 20.3111 13.5771 19.7314 13.8137L16.5908 15.0959C14.8521 15.8059 13.4726 17.1863 12.7627 18.925L11.4805 22.0657C11.2438 22.6453 10.4232 22.6452 10.1865 22.0657L8.9043 18.925C8.19436 17.1862 6.81403 15.8059 5.0752 15.0959L1.93457 13.8137C1.35515 13.577 1.35501 12.7564 1.93457 12.5198L5.0752 11.2375C6.81397 10.5276 8.19434 9.14817 8.9043 7.40942L10.1865 4.2688ZM18.6123 1.76099C18.7542 1.41354 19.2458 1.41354 19.3877 1.76099L19.9932 3.24243C20.135 3.58977 20.4105 3.86523 20.7578 4.00708L22.2393 4.61255C22.5867 4.7544 22.5867 5.24608 22.2393 5.38794L20.7578 5.99341C20.4105 6.13526 20.135 6.4107 19.9932 6.75806L19.3877 8.2395C19.2458 8.58695 18.7542 8.58695 18.6123 8.2395L18.0068 6.75806C17.865 6.4107 17.5895 6.13526 17.2422 5.99341L15.7607 5.38794C15.4133 5.24608 15.4133 4.7544 15.7607 4.61255L17.2422 4.00708C17.5895 3.86523 17.865 3.58977 18.0068 3.24243L18.6123 1.76099Z"
        fill="url(#paint1_radial_42_23148)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_42_23148"
          x1="37.1393"
          y1="12.0163"
          x2="-1.57582"
          y2="8.72494"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.197115" stopColor="#0FF0FF" />
          <stop offset="0.536748" stopColor="#4B95FF" />
          <stop offset="1" stopColor="#1E72EB" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_42_23148"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(27.0071 14.949 -58.0181 70.9518 5.65624 -8.70842)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1CFFBA" />
          <stop offset="0.654851" stopColor="#08FFB5" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default SparkleIcon;
